import { Modal } from 'antd'
import React from 'react'
import TestRunForm from './TestRunForm'

const CreateTestRunModal = (props) => {
    const { isOpen = false, setOpen = () => {}, selectedRowKeys = [] } = props

    console.log('Log ==>selectedRowKeys', selectedRowKeys)

    return (
        <Modal
            closable={true}
            open={isOpen}
            onCancel={() => {
                setOpen(false)
            }}
            destroyOnClose={true}
            width={540}
            footer={null}
            centered
            title={'Create Test run '}
        >
            <TestRunForm selectedRowKeys={selectedRowKeys} setOpen={setOpen} />
        </Modal>
    )
}

export default CreateTestRunModal
